import translationKeys from '@translationKeys'

export default {
  [translationKeys.SEARCH_THE_PONE_PLUS_DATABASE]: 'Search the partneringONE plus database',
  [translationKeys.HUB_SEARCH_DESCRIPTION]:
    // eslint-disable-next-line max-len
    'Search across <bold>19,000 partnering ready assets</bold> and technologies or <bold>connect with one of the 11,500+ companies</bold> seeking in-licensing and out-licensing partnerships.',
  [translationKeys.HUB_SEARCH_PLACEHOLDER]: 'Start finding partnering opportunities',
  [translationKeys.START_A_FILTERED_SEARCH]: 'Start a filtered search',
  [translationKeys.SUBMIT]: 'Submit',
  [translationKeys.CONTACT_CENTER]: 'Contact center',
  [translationKeys.ANSWER_THE_LATEST_MESSAGES_IN]: 'Answer the latest messages in',
  [translationKeys.YOUR]: 'your',
  [translationKeys.P1_PLUS_INBOX]: 'partneringONE plus inbox',
  [translationKeys.YOUR_CUSTOM_LISTS]: 'Your custom lists',
  [translationKeys.VIEW_AND_MANAGE_YOUR]: 'View and manage your',
  [translationKeys.CUSTOM_LISTS]: 'custom lists',
  [translationKeys.NOT_A_SUBSCRIBER]: 'Not a subscriber?',
  [translationKeys.NOT_A_SUBSCRIBER_DESCRIPTION_1]:
    // eslint-disable-next-line max-len
    'A partneringONE plus subscription provides access to our database of over 11,500+ companies who are actively seeking partners.',
  [translationKeys.NOT_A_SUBSCRIBER_DESCRIPTION_2]:
    // eslint-disable-next-line max-len
    'Year-round relationship management and partnering tracking tools gives you the advantage you need to find the right partner.',
  [translationKeys.NOT_A_SUBSCRIBER_DESCRIPTION_3]: 'Don’t miss out – find out more about a partneringONE plus subscription',
  [translationKeys.FIND_OUT_MORE]: 'Find out more',
  [translationKeys.WELCOME_TO]: 'Welcome to',
  [translationKeys.GO_TO]: 'Go to',
  [translationKeys.EVENT_PARTNERING]: 'Event Partnering',
  [translationKeys.ACCESS_ALL_YOUR_UPCOMING_EVENTS]: 'Access all your upcoming events',
  [translationKeys.ACCESS_YOUR_UPCOMING_EVENT]: 'Access your event',
  [translationKeys.SEE_PAST_EVENTS]: 'Access your past events',
  [translationKeys.QUESTIONS_EMAIL_US_AT]: 'Questions? Email us at',
  [translationKeys.FOR_HELP_MANAGING_YOUR_P1_PLUS_ACCOUNT]: 'for help managing your partneringONE plus account',
  [translationKeys.VIEW_THE_USER_GUIDE]: 'View the user guide',
  [translationKeys.SORRY_YOUR_ACCOUNT_FOR_THIS_EVENT_IS_NOT_READY_YET]:
    // eslint-disable-next-line max-len
    'Sorry - Your account for this event is not ready yet. You will receive an email when you can access partnering for the event.',
  [translationKeys.SORRY_YOUR_ACCOUNT_FOR_THIS_EVENT_IS_BLOCKED]: 'Sorry - Your account for this event is blocked.',
  [translationKeys.SORRY_ACCESS_ISNT_OPEN_FOR_THIS_EVENT_JUST_YET]: 'Sorry - Access isn’t open for this event just yet.',
  [translationKeys.SORRY_AGENDA_ISNT_OPEN_FOR_THIS_EVENT_JUST_YET]:
    'Sorry - Agenda isn’t open for this event just yet. In the meantime, set up your company profile on your desktop computer.',
  [translationKeys.FIND_CONNECT_AND_MANAGE]: 'Find, connect and manage your licensing year-round',
  [translationKeys.LAUNCH_PARTNERING_ONE_PLUS]: 'Launch partneringONE plus',
  [translationKeys.TO_FIND_CONNECT_AND_MANAGE]:
    'To find, connect, and manage your licensing year-round, subscribe to partneringONE plus',
  [translationKeys.UPCOMING_EVENT]: 'Upcoming Event',
  [translationKeys.UPCOMING_EVENTS]: 'Upcoming Events',
  [translationKeys.PAST_EVENT]: 'Past Event',
  [translationKeys.PAST_EVENTS]: 'Past Events',
  [translationKeys.SEE_ALL]: 'See All',
  [translationKeys.SEE_YOUR]: 'See Your',
  [translationKeys.EVENTS]: 'events',
  [translationKeys.EVENT]: 'event',
  [translationKeys.PLUS]: 'plus +',
}
